import * as d3 from 'd3';
import Axis from './Axis.js';

export default class QuarterAxis extends Axis {
  constructor(props) {
    super(props);

    this.axis = d3.axisBottom(this.xScale).ticks(d3.timeMonth.every(3));
  }

  removeText() {
    const { chart } = this.props;

    chart.selectAll('.quarter .tick text').remove();

    return this;
  }

  addMonthGrid() {
    const {
      chart,
      options: { height, scaleType },
    } = this.props;
    chart
      .selectAll('.quarter .tick')
      .select('line')
      .transition()
      .duration(0)
      .attr('stroke-dasharray', `${scaleType === 'year' ? '3.3' : false}`)
      .attr('y2', height);

    return this;
  }

  removeDomainPath() {
    const { chart } = this.props;

    chart.select('.quarter .domain').remove();

    return this;
  }

  update() {
    const { chart } = this.props;

    this.axis.scale(this.xScale);

    chart
      .select('.axis.quarter')
      .transition()
      .duration(this.transitionDuration)
      .call(this.axis);

    this.removeText().addMonthGrid().removeDomainPath();
  }

  build() {
    const { chart } = this.props;

    chart
      .append('g')
      .attr('class', 'axis quarter')
      .attr('transform', 'translate(0,0)')
      .call(this.axis);

    this.removeText().addMonthGrid().removeDomainPath();
  }
}
